<template>
    <div class="button-create-post">
        <div class="position-relative">
            <button
                v-b-modal.createPageModal
                class="btn btn-large btn-primario d-flex align-items-center px-4 py-3"
                @click="$emit('createPost', pageId)"
            >
                <i class="fas fa-plus button-create-post-icon"></i>&nbsp;Criar
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ButtonCreatePost",
    props: {
        pageId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
        }
    },
}
</script>

<style>
    .button-create-post {
        z-index: 10;
        position: fixed;
        left: 50%;
        bottom: 1rem;
        transform: translateX(-50%);
    }

    .button-create-post {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        width: 60px;
        padding: 1em;
        border-radius: 50%;
    }
    
    .button-create-post .button-create-post-icon {
        font-size: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/molecules/ButtonCreatePost.vue